import React from 'react';
import { CalendarClockIcon } from '../../../components';
import { LinkTokenErrorScreen } from './LinkTokenErrorScreen';

/**
 * 招待リンクの有効期限が切れていた場合に表示するフルページ画面。
 * デイサービス側でのアカウント再発行を案内する。
 */
export const LinkExpired: React.FC = () => {
  return (
    <LinkTokenErrorScreen
      icon={<CalendarClockIcon />}
      title="有効期限が切れています"
      description={'恐れ入りますが、\nデイサービスからアカウントを\n再度発行いただくようお願いします。'}
    />
  );
};

export default LinkExpired;
